module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-68-min.5f8e1877.jpg";